var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsShrinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 0.188965L8.62497 3.37647V0.833548H7.2083V5.79188H12.1666V4.37522H9.62372L12.8112 1.18771L11.8125 0.188965ZM0.833304 7.20855V8.62522H3.37622L0.188721 11.8127L1.18747 12.8115L4.37497 9.62397V12.1669H5.79164V7.20855H0.833304Z",
    fill: "#7CBE7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsShrinkIcon);
export default __webpack_public_path__ + "static/media/arrows-shrink-icon.c898998fcadf898c6791a7088dc45c73.svg";
export { ForwardRef as ReactComponent };